<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th> МИН </th>
        <th> МАКС </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="prop in rowsData" :key="prop.PROP_ID">
        <td>
          {{ numLocaleDecorator(prop.PROP_MIN) }}
        </td>
        <td>
          {{ numLocaleDecorator(prop.PROP_MAX) }}
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { RCPT_GET_RCPT_PROPERTIES } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'
export default {
  name: 'tblCalculationRcpLimits',
  mixins: [numDecorator],
  props: {
    recepture: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      rows: []
    }
  },
  computed: {
    rowsData: {
      get () {
        return this.rows
      }
    }
  },
  watch: {
    recepture (val) {
      if (val && val.ULF_UUID) {
        this.getProperties()
      } else {
        this.rows.splice(0, this.rows.length)
      }
    }
  },
  methods: {
    getProperties () {
      this.$store.dispatch(RCPT_GET_RCPT_PROPERTIES, { ULF_ID: this.recepture.ULF_ID || null, ULF_UUID: this.recepture.ULF_UUID || null })
        .then((res) => {
          this.rows.splice(0, this.rows.length, ...res)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${err}` })
        })
    }
  },
  mounted () {
    this.getProperties()
  }
}
</script>

<style scoped>

</style>
